import { OrganizationUIStyle } from '@/api/rest/resources/types/organization';

import { useOrganizationProducts } from './useOrganizationProducts';

export const useUIStyle = (uiStyle: OrganizationUIStyle): boolean => {
  const organizationProducts = useOrganizationProducts(undefined, true);

  return organizationProducts.data?.some((product) => product.ui_style === uiStyle) ?? false;
};
